/* eslint-disable no-unused-expressions */
import React, { useCallback, useMemo } from 'react'
import Avatar, { ugcUserLink } from 'Components/author/avatar'
import { Image, ImageZoom } from 'Components/view-image'
import {
  DiggButton,
  stopPropagation,
} from 'Components/new/community-card/interact'
import { CardCollectButton, Duration } from '../common-card'
import classNames from 'classnames'
import { size14Class } from 'Components/new/community-card/text'

interface IProps {
  order?: number
  className?: string
  uniqueIdStr: string
  title: string
  coverUrl: string
  publishTime: number
  duration?: number | string
  userId: string
  avatar: string
  name: string
  userVerified?: boolean
  verifyType?: number
  cellStyle?: number
  articleType?: number
  userDigg?: boolean
  diggCount?: number
  discussId?: string
  discussName?: string
  collected?: boolean
  collectVisible?: boolean
  discussClick?: () => void
  onClick?(): void
  onClickUser?(): void
  onClickDigg?(curStatus: boolean): void
  onClickCollect?(curStatus: boolean): void
}

const SmallVideoCard: React.FC<IProps> = ({
  order,
  uniqueIdStr,
  title,
  coverUrl,
  name,
  userVerified,
  verifyType,
  className,
  userId,
  publishTime,
  duration,
  avatar,
  userDigg,
  diggCount,
  discussId,
  discussName,
  cellStyle,
  articleType,
  collected,
  collectVisible = true,
  discussClick,
  onClick,
  onClickUser,
  onClickDigg,
  onClickCollect,
  ...props
}) => {
  const ugcUserLinkWrapper = useMemo(() => ugcUserLink({ userId }), [userId])

  return (
    <div
      className={`small-video-card tw-overflow-hidden tw-rounded-2 tw-relative ${
        className ? className : ''
      }`}
      {...props}
    >
      {!!discussId && !!discussName ? (
        <a
          className="discuss-link g-one-line-text"
          href={`/community/${discussId}`}
          target="_blank"
          onClick={(e) => {
            e.stopPropagation()
            discussClick?.()
          }}
        >
          <span className="tw-relative tw-z-10">{discussName}</span>
        </a>
      ) : null}
      {collectVisible ? (
        <CardCollectButton
          onClick={onClickCollect}
          id={uniqueIdStr}
          collected={collected}
        />
      ) : null}
      <Duration
        duration={duration}
        className="tw-absolute tw-right-8 tw-bottom-104 tw-z-10"
      />
      <Image
        src={coverUrl}
        width={210}
        height={380}
        lazy={true}
        autoPixelRatio
        className="small-video-bg-image"
        layout={'responsive'}
        objectFit={'cover'}
      />
      <a
        className="tw-absolute tw-w-full tw-h-full"
        href={`/ugc/article/${uniqueIdStr}`}
        target="_blank"
        onClick={onClick}
        style={{ position: 'absolute', top: -48 }}
      >
        <Image
          src={coverUrl}
          alt={title}
          width={210}
          height={380}
          lazy={true}
          hoverTransition={true}
          objectFit={'contain'}
          layout={'fill'}
          className="tw-bg-common-black tw-bg-opacity-80 tw-backdrop-filter tw-backdrop-blur-md"
        />
      </a>
      <div className="tw-absolute tw-bottom-0 tw-inset-x-0 tw-h-96 tw-flex tw-flex-col tw-justify-between tw-z-10 tw-p-12 tw-bg-white">
        <h3
          title={title}
          className={classNames(
            'tw-leading-20 tw-font-medium line-2',
            size14Class
          )}
        >
          <a
            title={title}
            onClick={onClick}
            href={`/ugc/article/${uniqueIdStr}`}
            target="_blank"
          >
            {title}
          </a>
        </h3>
        <div className="tw-h-20 tw-flex tw-items-center">
          <Avatar
            avatar={avatar}
            userId={userId}
            username={name}
            userVerified={userVerified}
            verifyType={verifyType}
            size={20}
            verifySize={8}
            onClick={onClickUser}
            className="tw-mr-4"
          />
          <p
            className="tw-text-common-gray line-1 tw-mr-12 tw-flex-1 tw-text-12"
            onClick={stopPropagation(onClickUser)}
          >
            {ugcUserLinkWrapper(name)}
          </p>
          <DiggButton
            cellStyle={cellStyle}
            articleType={articleType}
            size="mini"
            hasDigg={userDigg}
            diggCount={diggCount}
            id={uniqueIdStr}
            onClick={onClickDigg}
            className="hover:tw-text-common-orange"
          />
        </div>
      </div>
      <style jsx>
        {`
          .discuss-link {
            position: absolute;
            top: 0;
            padding: 0 12px 0 6px;
            font-size: 12px;
            height: 20px;
            line-height: 20px;
            z-index: 2;
            max-width: 60%;
            color: #fff;
          }
          .discuss-link:hover:before {
            border-top-color: rgba(96, 99, 112, 0.8);
          }
          .discuss-link:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            z-index: 0;
            border-top: 20px solid rgba(0, 0, 0, 0.6);
            width: 100%;
            height: 0;
            border-bottom: none;
            border-left: none;
            border-right: 8px solid transparent;
          }
          .small-video-card:hover :global(.collect-btn) {
            display: block;
          }
        `}
      </style>
    </div>
  )
}

export default SmallVideoCard
